/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelsRoutingModule } from './hotels-routing.module';
import { HotelsListComponent } from '@app/hotels/hotels/hotels-list/hotels-list.component';
import { HotelsFormComponent } from '@app/hotels/hotels/hotels-form/hotels-form.component';
import { HotelsViewComponent } from './hotels/hotels-view/hotels-view.component';
import { SharedModule } from '@app/shared';
import { HotelsService } from '@app/hotels/hotels/hotels.service';
import { HotelsFormService } from '@app/hotels/hotels/hotels-form.service';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { HotelBookingsListComponent } from './hotel-bookings/hotel-bookings-list/hotel-bookings-list.component';
import { HotelBookingsFormComponent } from './hotel-bookings/hotel-bookings-form/hotel-bookings-form.component';
import { HotelBookingsPreviewRoomsComponent } from './hotel-bookings/hotel-bookings-preview-rooms/hotel-bookings-preview-rooms.component';
import { HotelBookingsService } from '@app/hotels/hotel-bookings/hotel-bookings.service';
import { HotelBookingsFormService } from '@app/hotels/hotel-bookings/hotel-bookings-form.service';
// tslint:disable-next-line:max-line-length
import { HotelBookingCancellationsListComponent } from './hotel-booking-cancellations/hotel-booking-cancellations-list/hotel-booking-cancellations-list.component';
// tslint:disable-next-line:max-line-length
import { HotelBookingCancellationsViewComponent } from './hotel-booking-cancellations/hotel-booking-cancellations-view/hotel-booking-cancellations-view.component';
import { HotelsSeoFormComponent } from './hotels/hotels-seo-form/hotels-seo-form.component';
import { HotelBookingsRoomsListComponent } from './hotel-bookings/hotel-bookings-rooms-list/hotel-bookings-rooms-list.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { HotelBookingsViewComponent } from '@app/hotels/hotel-bookings/hotel-bookings-view/hotel-bookings-view.component';
import {
  GooglePlacesAutocompleteComponent
} from '@app/shared/components/google-places-autocomplete/google-places-autocomplete.component';

@NgModule({
  declarations: [
    HotelsListComponent,
    HotelsFormComponent,
    HotelsViewComponent,
    HotelBookingsListComponent,
    HotelBookingsFormComponent,
    HotelBookingCancellationsListComponent,
    HotelBookingCancellationsViewComponent,
    HotelsSeoFormComponent,
    HotelBookingsRoomsListComponent,
    HotelBookingsViewComponent,
    HotelBookingsPreviewRoomsComponent,
  ],
  imports: [CommonModule, HotelsRoutingModule, SharedModule, GridModule, GooglePlacesAutocompleteComponent],
  providers: [HotelsService, HotelsFormService, KendoGridService, HotelBookingsService, HotelBookingsFormService],
})
export class HotelsModule {}
